const dataLayer = typeof window === 'undefined' ? undefined : window.dataLayer;

export default dataLayer;
